import React, {useState} from 'react';

function StartNewPayroll() {

    return (
        <div className='content' style={{ padding: "16px 24px 16px 16px" }}>
            <div className="start-new-payroll-section">
                {/* <div className='breadcrumb-section pb-3 border-bottom mb-3'>
                    <h2 className='main-title mb-1'>Payroll</h2>
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item"><a href="home">Home</a></li>
                            <li className="breadcrumb-item"><a href="dashboard">Dashboard</a></li>
                            <li className="breadcrumb-item"><a href="start-new-payroll">Start New Payroll</a></li>
                        </ol>
                    </nav>
                </div> */}
                <div>
                    <div className="row">
                        <div className="col-lg-8">
                            <h2 className='sub-title fw-semibold mb-1'>Add Payroll</h2>
                            <p className='description mt-2'>Complete the information below to start running a new payroll.
                                You'll then be able to add employee and contractor payments to this payoll.
                            </p>
                            <form>
                                <div className='mt-4'>
                                    <label>Processing Period</label>
                                    <select className='input-search w-100'>
                                        <option value="1">Processing Period</option>
                                    </select>
                                </div>
                                <div className='mt-4'>
                                    <label>Processing Period</label>
                                    <select className='input-search w-100'>
                                        <option value="1">Processing Period</option>
                                    </select>
                                </div>
                            </form>
                            <div className='d-flex align-items-center gap-3 mt-5 pb-5'>
                                <button className='button-orange px-5'>Start Payroll</button>
                                <button className='cancel-button'>Cancel</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}


export default StartNewPayroll;
